module.exports = __webpack_public_path__ + "img/ic_up_down_disable.1de7b77f.svg";